// ===========================================
// GSLC WEBSITE CONFIGURATION
// ===========================================

export const WEB3FORMS_ACCESS_KEY = "86278cb6-637a-433a-91cf-29bfc47764f6";

// Email where all form submissions will be sent
export const CONTACT_EMAIL = "pankaj@gslc.co.in";
